import React, { useState } from "react";
import { FaPlay, FaImages } from "react-icons/fa";

const Onest = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  message: ""
});

  // Sample images for the screenshot gallery
  const screenshotImages = [
    "/images/eventime/Live1.png",
    "/images/eventime/Live2.png",
    "/images/eventime/Live3.png",
    "/images/eventime/Live4.png",
    "/images/eventime/Live5.png",
    "/images/eventime/Live6.png"
  ];

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === screenshotImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? screenshotImages.length - 1 : prevIndex - 1
    );
  };

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData({
    ...formData,
    [name]: value
  });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phonenumber: formData.phone,
      email: formData.email,
      message: formData.message,
      type: "contact"
    };

    const response = await fetch("https://tnreaders.in/web/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      console.log("Form submitted successfully");
      // Reset form and close modal
      setFormData({ 
        firstName: "", 
        lastName: "", 
        phone: "", 
        email: "", 
        message: "" 
      });
      setShowEnquiryModal(false);
      alert("Thank you for your enquiry! We'll contact you soon.");
    } else {
      throw new Error("Failed to submit form");
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    alert("There was an error submitting your form. Please try again.");
  }
};
  return (
    <div className="onest-product">
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-modal" onClick={() => setShowModal(false)}>
              &times;
            </button>
            <div className="image-container">
              <img
                src={screenshotImages[currentImageIndex]}
                alt={`Screenshot ${currentImageIndex + 1}`}
              />
            </div>
            <div className="modal-navigation">
              <button className="nav-arrow" onClick={handlePrevImage}>
                &larr; Previous
              </button>
              <span className="image-counter">
                {currentImageIndex + 1} / {screenshotImages.length}
              </span>
              <button className="nav-arrow" onClick={handleNextImage}>
                Next &rarr;
              </button>
            </div>
          </div>
        </div>
      )}
{showEnquiryModal && (
  <div className="modal-overlay">
    <div className="modal-content enquiry-form">
      <button
        className="close-modal"
        onClick={() => setShowEnquiryModal(false)}
      >
        &times;
      </button>
      <h2>Request Demo</h2>
      <p>Please fill out this form to request a demo of our product.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <button type="submit" className="submit-btn">
          Submit Request
        </button>
      </form>
    </div>
  </div>
)}
      <div className="product-container">
        {/* Product Description Section */}
        <section className="product-description">
          <div className="section-header">
            <span className="section-badge">EDUCATION</span>
            <h1>MP-LMS</h1>
            <h2>Single Institution Learning Management System</h2>
          </div>
          <div className="description-content">
            <p>
              MP-LMS is a comprehensive Laravel-based Learning Management
              System designed for individual schools, training centers, and
              educational institutions. It provides all the tools needed to
              manage courses, students, and online learning in one unified
              platform.
            </p>
            <div className="highlight-box">
              <p>
                <strong>Key Benefit:</strong> Complete solution for single
                institutions to deliver, track, and manage educational content
                with intuitive interfaces for both instructors and learners.
              </p>
            </div>
          </div>
        </section>

        <div className="btnalignmnt">
          <button
            className="livepreview"
            onClick={() => setShowEnquiryModal(true)}
          >
            <FaPlay style={{ marginRight: "8px" }} />
            Demo
          </button>
          <button className="screenshot" onClick={() => setShowModal(true)}>
            <FaImages style={{ marginRight: "8px" }} />
            Screenshots
          </button>
        </div>

        {/* Product Features Section */}
        <section className="product-features">
          <div className="section-header">
            <span className="section-badge">FEATURES</span>
            <h2>Core Learning Management Features</h2>
          </div>
          <div className="features-grid">
            {[
              {
                icon: "📚",
                title: "Course Management",
                description:
                  "Create and organize courses with lessons, quizzes, and resources"
              },
              {
                icon: "👨‍🏫",
                title: "Instructor Portal",
                description:
                  "Dedicated dashboard for course creators and teachers"
              },
              {
                icon: "🎓",
                title: "Student Progress",
                description: "Track completion, grades, and engagement metrics"
              },
              {
                icon: "🏫",
                title: "Single Institution",
                description: "Designed for one school or training organization"
              },
              {
                icon: "📱",
                title: "Mobile Ready",
                description: "Fully responsive design for all devices"
              },
              {
                icon: "📊",
                title: "Reporting",
                description:
                  "Generate insights on student performance and course effectiveness"
              }
            ].map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Technology Used Section */}
        <section className="technology-used">
          <div className="section-header">
            <span className="section-badge">TECHNOLOGY</span>
            <h2>Modern Educational Technology Stack</h2>
          </div>
          <div className="tech-stack">
            <div className="tech-category">
              <div className="tech-icon">💻</div>
              <h3>Frontend</h3>
              <ul>
                <li>HTML5, CSS3, JavaScript (ES6+)</li>
                <li>Bootstrap 4 responsive framework</li>
                <li>jQuery for interactive components</li>
                <li>AJAX for dynamic content</li>
              </ul>
            </div>

            <div className="tech-category">
              <div className="tech-icon">🔌</div>
              <h3>Backend</h3>
              <ul>
                <li>PHP 7.3+ (Laravel 7.x framework)</li>
                <li>MySQL relational database</li>
                <li>Eloquent ORM for data operations</li>
                <li>RESTful API endpoints</li>
              </ul>
            </div>

            <div className="tech-category">
              <div className="tech-icon">🛠️</div>
              <h3>Learning Tools</h3>
              <ul>
                <li>Video lesson support</li>
                <li>Interactive quizzes</li>
                <li>Discussion forums</li>
                <li>Assignment submission</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Course Components Section */}
        <section className="course-components">
          <div className="section-header">
            <span className="section-badge">CONTENT</span>
            <h2>Supported Learning Materials</h2>
          </div>
          <div className="components-grid">
            {[
              {
                icon: "🎥",
                type: "Video Lessons",
                description: "Embed or upload instructional videos"
              },
              {
                icon: "📄",
                type: "Documents",
                description: "PDFs, Word files, PowerPoint slides"
              },
              {
                icon: "✍️",
                type: "Assignments",
                description: "Student submissions with grading"
              },
              {
                icon: "❓",
                type: "Quizzes",
                description: "Multiple choice, true/false questions"
              },
              {
                icon: "💬",
                type: "Discussions",
                description: "Course forums and Q&A"
              },
              {
                icon: "📝",
                type: "Surveys",
                description: "Feedback collection tools"
              }
            ].map((component, index) => (
              <div className="component-card" key={index}>
                <div className="component-icon">{component.icon}</div>
                <h3>{component.type}</h3>
                <p>{component.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* User Roles Section */}
        <section className="user-roles">
          <div className="section-header">
            <span className="section-badge">USERS</span>
            <h2>System Roles & Permissions</h2>
          </div>
          <div className="roles-grid">
            <div className="role-card">
              <div className="role-icon">👨‍🎓</div>
              <h3>Students</h3>
              <ul>
                <li>Enroll in courses</li>
                <li>Submit assignments</li>
                <li>Track progress</li>
              </ul>
            </div>
            <div className="role-card">
              <div className="role-icon">👨‍🏫</div>
              <h3>Instructors</h3>
              <ul>
                <li>Create course content</li>
                <li>Grade assignments</li>
                <li>Monitor students</li>
              </ul>
            </div>
            <div className="role-card">
              <div className="role-icon">👨‍💼</div>
              <h3>Administrators</h3>
              <ul>
                <li>Manage all users</li>
                <li>Configure system</li>
                <li>Generate reports</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Learning Flow Section */}
        <section className="learning-flow">
          <div className="section-header">
            <span className="section-badge">WORKFLOW</span>
            <h2>Simple Learning Process</h2>
          </div>
          <div className="flow-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Enrollment</h3>
              <p>Students register and enroll in courses</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Learning</h3>
              <p>Access lessons and materials</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Assessment</h3>
              <p>Complete assignments and quizzes</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Completion</h3>
              <p>Receive grades and certificates</p>
            </div>
          </div>
        </section>
      </div>

      {/* CSS Styles with Education Theme */}
      <style>{`
        :root {
          --primary-color: rgb(14,89,145);
          --secondary-color: #137eb1;
          --light-accent: #f3e5f5;
          --dark-shade: #4a148c;
          --text-color: #2d3748;
          --light-text: #f8fafc;
        }
        
        .onest-product {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          line-height: 1.6;
          color: var(--text-color);
          margin: 0 auto;
          padding: 0rem;
          background: linear-gradient(135deg, #fdfcff 0%, #f5f0ff 100%);
        }
        
                      .btnalignmnt{
          display: flex;
    justify-content: center;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
        }

.livepreview,
.screenshot {
  border: none;
  background: white;
  box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
  border: 1px solid rgba(124, 1, 177, 0.1);
  padding: 10px 20px;
  border-radius: 10px;
  color: var(--primary-color);
  cursor: pointer;
  transition: all 0.3s ease;
}

.livepreview:hover,
.screenshot:hover {
  background-color: var(--primary-color);
  color: white;
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(124, 1, 177, 0.15);
}

        
        .navigation-buttons {
          position: fixed;
          top: 20px;
          right: 20px;
          display: flex;
          gap: 10px;
          z-index: 1000;
        }

        .admin-features{
            padding-top: 20px
        }
        
        .nav-button {
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          border: none;
          transition: all 0.3s ease;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

        .description-content{
            max-width: 800px;
        }

                /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1001;
        }
        
        .modal-content {
          background: white;
          padding: 2rem;
          border-radius: 10px;
          max-width: 80%;
          height: auto;
          position: relative;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
        }
        
        .close-modal {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: var(--text-color);
        }
        
        .image-container {
          margin: 1rem 0;
          text-align: center;
        }
        
        .image-container img {
          max-width: 100%;
          max-height: 500px;
          border-radius: 5px;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }
        
        .modal-navigation {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 1rem;
        }
        
        .nav-arrow {
          background: var(--primary-color);
          color: white;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .nav-arrow:hover {
          background: var(--dark-shade);
        }
        
        .image-counter {
          font-weight: 600;
        }
        
        .farmart-product {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          line-height: 1.6;
          color: var(--text-color);
          margin: 0 auto;
          padding: 0rem;
        }
        
        .product-container {
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(124, 1, 177, 0.1);
          padding: 2rem;
          overflow: hidden;
        }

        .product-description{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        }
        
        .section-header {
          margin-bottom: 2rem;
          position: relative;
        }
        
        .section-badge {
          display: inline-block;
          background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
          color: white;
          padding: 0.35rem 1rem;
          border-radius: 50px;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          margin-bottom: 1rem;
        }
        
        h1 {
          color: var(--primary-color);
          font-size: 2.5rem;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 0.5rem;
        }
        
        h2 {
          color: var(--dark-shade);
          font-size: 1.75rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          position: relative;
        }
        
        h3 {
          color: var(--primary-color);
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }
        
        p {
          margin-bottom: 1rem;
          color: var(--text-color);
          font-size: 1rem;
          line-height: 1.7;
        }
        
        .highlight-box {
          background: var(--light-accent);
          border-left: 4px solid var(--secondary-color);
          padding: 1.25rem;
          border-radius: 0 8px 8px 0;
          margin: 1.5rem 0;
        }
        
        .highlight-box p {
          margin: 0;
          color: var(--dark-shade);
        }
        
        .features-grid, .components-grid, .roles-grid {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-bottom: 2rem;
    gap: 20px;
        }
        
        .feature-card, .component-card, .role-card {
          background: white;
          padding: 1.5rem;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
          border: 1px solid rgba(124, 1, 177, 0.1);
          transition: all 0.3s ease;
        }
        
        .feature-card:hover, .component-card:hover, .role-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(124, 1, 177, 0.15);
        }
        
        .feature-icon, .component-icon, .role-icon {
          font-size: 2rem;
          margin-bottom: 1rem;
          color: var(--secondary-color);
        }
        
        .tech-stack {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            align-items: center;
            margin-bottom: 2rem;
        }

                .technology-used{
          padding-top: 20px;
        }
        
        .tech-category {
          background: white;
          padding: 1.5rem;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
          border: 1px solid rgba(124, 1, 177, 0.1);
              width: 30%;
    height: 400px;
        }
        
        .tech-icon {
          font-size: 1.5rem;
          margin-bottom: 1rem;
          color: var(--secondary-color);
        }
        
        .flow-steps {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 2rem;
        }
        
        .step {
          text-align: center;
        }
        
        .step-number {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          margin: 0 auto 1rem;
        }
        
        ul {
          padding-left: 1.25rem;
        }
        
        li {
          margin-bottom: 0.5rem;
        }
        
        @media (max-width: 768px) {
          .product-container {
            padding: 1.5rem;
          }
          
          h1 {
            font-size: 2rem;
          }
          
          h2 {
            font-size: 1.5rem;
          }
          
          .features-grid, .tech-stack, .components-grid, .roles-grid, .flow-steps {
            display: flex;
            flex-direction: column;
          }

          .tech-category {
    background: white;
    padding: 1.5rem;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
    border: 1px solid rgba(124, 1, 177, 0.1);
    width: 100%;
    height: auto;
}
        }
      `}</style>
    </div>
  );
};

export default Onest;
